import { BaseAction } from "../../../core/actions/BaseAction";
import { convertTimeToArabic } from "../../../Lib/Utils/validationUtil";
import { ILeg, IOffer, ITrip, ITripOfferModel } from "../../../Orchestrator/Types/Index";
import { IProcessBookItAgainOfferActionPrams } from "../../../Orchestrator/Types/Interface/ActionParams/ProcessBookItAgainOffer";
import { ProductCodeEnum, SHUTTLE_PRODUCT_CODE } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";


export class ProcessBookItAgainOfferAction extends BaseAction<ITripOfferModel[], IProcessBookItAgainOfferActionPrams> {

    override async run(): Promise<ITripOfferModel[]> {
        const tripOffers: ITripOfferModel[] = [];
        try {
            const { trips, offers, selectedTrip, isInbound = false } = this.params!
            
            // Filter trips that are after current time
            const futureTrips = trips.filter((trip: ITrip) =>
                new Date(trip.startTime) > new Date()
            );

            if (futureTrips.length === 0) return [];

            // For inbound journey, match all trips with their corresponding offers
            if (isInbound) {
                for (const trip of futureTrips) {
                    if (convertTimeToArabic(trip.startTime) === selectedTrip.inboundData.departureTime) {
                        let standardOffer: IOffer | undefined;
                        const standardOfferIndex = offers.findIndex(offer =>
                            offer.tripCoverage?.coveredTripId === trip.id &&
                            //offer.offerSummary?.overallServiceClass?.type === "STANDARD"
                            offer.products[0].code === ProductCodeEnum.SFC
                        );

                        if (standardOfferIndex !== -1) {
                            standardOffer = offers[standardOfferIndex];
                        }

                        let standardProOffer: IOffer | undefined;
                        const standardProOfferIndex = offers.findIndex(offer =>
                            offer.tripCoverage?.coveredTripId === trip.id &&
                            //offer.offerSummary?.overallServiceClass?.type === "STANDARD"
                            offer.products[0].code === ProductCodeEnum.SFF
                        );

                        if (standardProOfferIndex !== -1) {
                            standardProOffer = offers[standardProOfferIndex];
                        }

                        let premiumOffer: IOffer | undefined;
                        const premiumOfferIndex = offers.findIndex(offer =>
                            offer.tripCoverage?.coveredTripId === trip.id &&
                            //offer.offerSummary?.overallServiceClass?.type === "HIGH"
                            offer.products[0].code === ProductCodeEnum.PFF
                        );

                        if (premiumOfferIndex !== -1) {
                            premiumOffer = offers[premiumOfferIndex];
                        }

                        let standardDuoOffer: IOffer | undefined;
                        const standardDuoOfferIndex = offers.findIndex(offer =>
                            offer.tripCoverage?.coveredTripId === trip.id &&
                            offer.products[0].code === ProductCodeEnum.STDNFDUO
                        );

                        if (standardDuoOfferIndex !== -1) {
                            standardDuoOffer = offers[standardDuoOfferIndex];
                        }

                        let standardQuadOffer: IOffer | undefined;
                        const standardQuadOfferIndex = offers.findIndex(offer =>
                            offer.tripCoverage?.coveredTripId === trip.id &&
                            offer.products[0].code === ProductCodeEnum.STDNFQUAD
                        );

                        if (standardQuadOfferIndex !== -1) {
                            standardQuadOffer = offers[standardQuadOfferIndex];
                        }

                        let premiumDuoOffer: IOffer | undefined;
                        const premiumDuoOfferIndex = offers.findIndex(offer =>
                            offer.tripCoverage?.coveredTripId === trip.id &&
                            offer.products[0].code === ProductCodeEnum.PREMNFDUO
                        );

                        if (premiumDuoOfferIndex !== -1) {
                            premiumDuoOffer = offers[premiumDuoOfferIndex];
                        }

                        let premiumQuadOffer: IOffer | undefined;
                        const premiumQuadOfferIndex = offers.findIndex(offer =>
                            offer.tripCoverage?.coveredTripId === trip.id &&
                            offer.products[0].code === ProductCodeEnum.PREMNFQUAD
                        );

                        if (premiumQuadOfferIndex !== -1) {
                            premiumQuadOffer = offers[premiumQuadOfferIndex];
                        }
                        
                        if (trip?.legs?.length > 0) {
                            trip.legs = trip?.legs?.map((leg: ILeg) => {
                                const legOffers: IOffer[] | undefined = offers.filter(offer => offer?.tripCoverage?.coveredTripId === trip.id && offer.tripCoverage?.coveredLegIds?.includes(leg.id));
                                if (legOffers) {
                                    leg.legOffer = [...legOffers];
                                }
                                return leg;
                            })
                        }

                        tripOffers.push({
                            trip,
                            standardOffer,
                            standardProOffer,
                            premiumOffer,
                            standardDuoOffer,
                            standardQuadOffer,
                            premiumDuoOffer,
                            premiumQuadOffer,
                        });
                    }
                }

                return tripOffers;
            }

            // For outbound journey, try to match the departure time
            for (const trip of futureTrips) {
                if (convertTimeToArabic(trip.startTime) === selectedTrip.departureTime) {
                    let standardOffer: IOffer | undefined;
                    const standardOfferIndex = offers.findIndex(offer =>
                        offer.tripCoverage?.coveredTripId === trip.id &&
                        //offer.offerSummary?.overallServiceClass?.type === "STANDARD"
                        offer.products[0].code === ProductCodeEnum.SFC
                    );

                    if (standardOfferIndex !== -1) {
                        standardOffer = offers[standardOfferIndex];
                    }

                    let shuttleOffer: IOffer | undefined;
                    const shuttleOfferIndex = offers.findIndex(offer =>
                        offer.tripCoverage?.coveredTripId === trip.id &&
                        //offer.offerSummary?.overallServiceClass?.type === "STANDARD"
                        offer.products[0].code === SHUTTLE_PRODUCT_CODE
                    );

                    if (shuttleOfferIndex !== -1) {
                        shuttleOffer = offers[shuttleOfferIndex];
                    }

                    let standardProOffer: IOffer | undefined;
                    const standardProOfferIndex = offers.findIndex(offer =>
                        offer.tripCoverage?.coveredTripId === trip.id &&
                        //offer.offerSummary?.overallServiceClass?.type === "STANDARD"
                        offer.products[0].code === ProductCodeEnum.SFF
                    );

                    if (standardProOfferIndex !== -1) {
                        standardProOffer = offers[standardProOfferIndex];
                    }

                    let premiumOffer: IOffer | undefined;
                    const premiumOfferIndex = offers.findIndex(offer =>
                        offer.tripCoverage?.coveredTripId === trip.id &&
                        //offer.offerSummary?.overallServiceClass?.type === "HIGH"
                        offer.products[0].code === ProductCodeEnum.PFF
                    );

                    if (premiumOfferIndex !== -1) {
                        premiumOffer = offers[premiumOfferIndex];
                    }

                    let standardDuoOffer: IOffer | undefined;
                    const standardDuoOfferIndex = offers.findIndex(offer =>
                        offer.tripCoverage?.coveredTripId === trip.id &&
                        offer.products[0].code === ProductCodeEnum.STDNFDUO
                    );

                    if (standardDuoOfferIndex !== -1) {
                        standardDuoOffer = offers[standardDuoOfferIndex];
                    }

                    let standardQuadOffer: IOffer | undefined;
                    const standardQuadOfferIndex = offers.findIndex(offer =>
                        offer.tripCoverage?.coveredTripId === trip.id &&
                        offer.products[0].code === ProductCodeEnum.STDNFQUAD
                    );

                    if (standardQuadOfferIndex !== -1) {
                        standardQuadOffer = offers[standardQuadOfferIndex];
                    }

                    let premiumDuoOffer: IOffer | undefined;
                    const premiumDuoOfferIndex = offers.findIndex(offer =>
                        offer.tripCoverage?.coveredTripId === trip.id &&
                        offer.products[0].code === ProductCodeEnum.PREMNFDUO
                    );

                    if (premiumDuoOfferIndex !== -1) {
                        premiumDuoOffer = offers[premiumDuoOfferIndex];
                    }

                    let premiumQuadOffer: IOffer | undefined;
                    const premiumQuadOfferIndex = offers.findIndex(offer =>
                        offer.tripCoverage?.coveredTripId === trip.id &&
                        offer.products[0].code === ProductCodeEnum.PREMNFQUAD
                    );

                    if (premiumQuadOfferIndex !== -1) {
                        premiumQuadOffer = offers[premiumQuadOfferIndex];
                    }
                    
                    if (trip?.legs?.length > 0) {
                        trip.legs = trip?.legs?.map((leg: ILeg) => {
                            const legOffers: IOffer[] | undefined = offers.filter(offer => offer?.tripCoverage?.coveredTripId === trip.id && offer.tripCoverage?.coveredLegIds?.includes(leg.id));
                            if (legOffers) {
                                leg.legOffer = [...legOffers];
                            }
                            return leg;
                        })
                    }

                    tripOffers.push({
                        trip,
                        standardOffer,
                        standardProOffer,
                        premiumOffer,
                        shuttleOffer,
                        standardDuoOffer,
                        standardQuadOffer,
                        premiumDuoOffer,
                        premiumQuadOffer
                    });
                }
            }

        } catch (error) {

        }
        finally {
            return tripOffers;
        }
    }
}

export const processBookItAgainOfferAction = new ProcessBookItAgainOfferAction(); 